/**
 * JU!CE — Hero v2 (sections/jp-hero.liquid).
 *
 * A troca de sabor em si é do <jp-flavor-switch> (assets/jp-motion.js): ele
 * escreve document.body.dataset.flavor, sincroniza aria-pressed dos chips e
 * faz o cross-fade dos [data-flavor-img]. Este arquivo faz só a parte que o
 * componente genérico não sabe fazer: escrever o NOME do sabor ativo no
 * eyebrow ("JU!CE PROTE!N · TANGERINA").
 *
 * Observa o atributo data-flavor do <body> em vez de escutar apenas o evento
 * jp:flavor-change, para acompanhar também quem mudar o sabor por fora
 * (assets/jp-flavor.js, PDP, carrinho).
 */
(function () {
  'use strict';

  var LABEL_SELECTOR = '[data-jp-hero-flavor-name]';
  var CHIP_SELECTOR = '[data-flavor-label][data-flavor-target]';

  function labelFor(flavor) {
    if (!flavor) return null;
    var chip = document.querySelector(CHIP_SELECTOR + '[data-flavor-target="' + flavor + '"]');
    return chip ? chip.getAttribute('data-flavor-label') : null;
  }

  function sync() {
    var nodes = document.querySelectorAll(LABEL_SELECTOR);
    if (!nodes.length) return;

    var flavor = document.body.getAttribute('data-flavor');
    var label = labelFor(flavor);
    if (!label) return;

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== label) {
        nodes[i].textContent = label;
      }
    }

    /* 15/09: CTA da oferta acompanha o sabor ativo (data-flavor-url no chip). */
    var cta = document.querySelector('[data-jp-hero-cta-oferta]');
    if (cta) {
      var chip = document.querySelector(CHIP_SELECTOR + '[data-flavor-target="' + flavor + '"]');
      var url = chip ? chip.getAttribute('data-flavor-url') : null;
      if (url && cta.getAttribute('href') !== url) cta.setAttribute('href', url);
    }
  }

  function boot() {
    sync();

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(document.body, {
        attributes: true,
        attributeFilter: ['data-flavor']
      });
    } else {
      document.addEventListener('jp:flavor-change', sync);
    }

    document.addEventListener('shopify:section:load', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
